/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Policy_Rights_Rectification_DescInputs */

const es_privacy_policy_rights_rectification_desc = /** @type {(inputs: Privacy_Policy_Rights_Rectification_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Correccion de informacion inexacta o incompleta`)
};

const en_privacy_policy_rights_rectification_desc = /** @type {(inputs: Privacy_Policy_Rights_Rectification_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Correct inaccurate or incomplete information`)
};

/**
* | output |
* | --- |
* | "Correct inaccurate or incomplete information" |
*
* @param {Privacy_Policy_Rights_Rectification_DescInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const privacy_policy_rights_rectification_desc = /** @type {((inputs?: Privacy_Policy_Rights_Rectification_DescInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Policy_Rights_Rectification_DescInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_privacy_policy_rights_rectification_desc(inputs)
	return en_privacy_policy_rights_rectification_desc(inputs)
});
export { privacy_policy_rights_rectification_desc as "privacy_policy.rights.rectification_desc" }